import { useEffect } from "react";
import { createPortal } from "react-dom";
import { IonButton, IonIcon } from "@ionic/react";
import { closeOutline } from "ionicons/icons";

// Full-screen image preview modal (lightbox). Renders nothing without a src;
// closes on backdrop click, the X, or Escape.
export default function ImageLightbox({ src, onClose }) {
  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [src, onClose]);

  if (!src) return null;
  return createPortal(
    <div
      onClick={onClose}
      role="dialog"
      aria-label="Image preview"
      style={{
        position: "fixed", inset: 0, zIndex: 30000,
        background: "rgba(0, 0, 0, 0.85)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 24, cursor: "zoom-out",
      }}
    >
      <IonButton
        fill="clear"
        shape="round"
        aria-label="Close preview"
        onClick={(e) => { e.stopPropagation(); onClose?.(); }}
        style={{
          position: "absolute", top: "calc(10px + env(safe-area-inset-top, 0px))", right: 10,
          "--color": "#fff",
          "--background": "rgba(255, 255, 255, 0.16)",
          "--background-hover": "rgba(255, 255, 255, 0.26)",
          "--border-radius": "50%",
          "--padding-start": "8px", "--padding-end": "8px",
          width: 44, height: 44, margin: 0,
        }}
      >
        <IonIcon slot="icon-only" icon={closeOutline} />
      </IonButton>
      <img
        src={src}
        alt=""
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: "100%", maxHeight: "100%", borderRadius: 10,
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.5)", cursor: "default",
          objectFit: "contain",
        }}
      />
    </div>,
    document.body
  );
}
